var getResponseErrorMessage = function getResponseErrorMessage(response) {
  return response && response.message || 'Something went wrong!';
};

export { getResponseErrorMessage as default };
//# sourceMappingURL=index.js.map
